<template> 
  <project-form :is-edit='true' :pno='pno'></project-form>
</template>
<script>
  import ProjectForm from './projectForm'
  export default {
    name: 'projectUpdate',
    components: { ProjectForm },
    data() {
      return {
        pno: ''
      }
    },
    created() {
      this.pno = this.$route.query.pno
    },    
  }
</script>
<style>
</style>


